import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Buttons = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x4};
`;

export const Button = styled.button`
  width: 147px;
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
`;

export const KidsDetailModalContainer = styled.div`
  width: 566px;
  max-width: 95%;
`;
